module.exports = __webpack_public_path__ + "Pe-icon-7-filled.svg?7aa42d27c82ed569c6789c71f45adbcc";